(function() {
  // 1. 純 CSS 防護罩
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes cartWeightPulse {
      0% { opacity: 0.4; }
      50% { opacity: 0.9; }
      100% { opacity: 0.4; }
    }
    body.cart-is-updating [data-cart-weight] {
      color: transparent !important; 
      position: relative;
    }
    body.cart-is-updating [data-cart-weight]::after {
      content: "計算中...";
      color: #888;
      position: absolute;
      left: 0;
      top: 0;
      animation: cartWeightPulse 1s infinite ease-in-out;
      pointer-events: none;
      white-space: nowrap;
    }
  `;
  document.head.appendChild(style);

  let syncTimer;
  let savedUnit = "g";

  // 【關鍵過濾器】只抓取「真正會改變購物車內容」的請求
  function isCartModification(urlInput, methodInput) {
    let url = '';
    if (typeof urlInput === 'string') {
      url = urlInput;
    } else if (urlInput && typeof urlInput === 'object' && urlInput.url) {
      url = urlInput.url;
      if (!methodInput && urlInput.method) methodInput = urlInput.method;
    }
    if (!url) return false;

    url = url.toLowerCase();
    const method = (methodInput || 'GET').toUpperCase();

    // 只有 POST 請求才會真正改變購物車的重量 (過濾掉我們自己的 GET 請求)
    if (method !== 'POST') return false;

    // 只有這些特定的 Shopify 原生動作會影響重量 (徹底忽略折扣 App)
    return url.includes('/cart/add') ||
           url.includes('/cart/change') ||
           url.includes('/cart/update') ||
           url.includes('/cart/clear');
  }

  // 啟動防護罩
  function showShield() {
    document.body.classList.add('cart-is-updating');
    clearTimeout(syncTimer);

    const elem = document.querySelector('[data-cart-weight]');
    if (elem && !elem.innerText.includes('計算中')) {
      const parts = elem.innerText.trim().split(" ");
      if (parts.length > 1) {
        savedUnit = parts[1];
      }
    }
  }

  // 安排抓取最新重量
  function scheduleSync() {
    clearTimeout(syncTimer);
    // 等待 600ms 讓主題和 App 的背景運算都跑完，我們再去抓最終答案
    syncTimer = setTimeout(syncCartWeight, 600);
  }

  // 抓取最終重量並解除防護罩
  function syncCartWeight() {
    // 這裡發出的是 GET 請求，會被上面的 isCartModification 直接放行，保證不迴圈
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const elem = document.querySelector('[data-cart-weight]');
        if (elem) {
          const unit = savedUnit;
          let displayWeight;
          if (unit.toLowerCase() === 'kg') {
            displayWeight = (cart.total_weight / 1000).toFixed(2);
          } else {
            displayWeight = cart.total_weight.toFixed(0);
          }
          elem.textContent = displayWeight + " " + unit;
        }
        document.body.classList.remove('cart-is-updating');
      })
      .catch(err => {
        document.body.classList.remove('cart-is-updating');
      });
  }

  // 1. 攔截 Fetch 請求
  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    const options = arguments[1] || {};
    const method = options.method || 'GET';

    if (isCartModification(url, method)) {
      showShield();
      return originalFetch.apply(this, arguments)
        .then(res => {
          scheduleSync();
          return res;
        })
        .catch(err => {
          scheduleSync();
          throw err;
        });
    }
    return originalFetch.apply(this, arguments);
  };

  // 2. 攔截 XHR 請求
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._reqMethod = method;
    this._reqUrl = url;
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (isCartModification(this._reqUrl, this._reqMethod)) {
      showShield();
      this.addEventListener('loadend', function() {
        scheduleSync();
      });
    }
    return originalSend.apply(this, arguments);
  };
})();